module.exports = __webpack_public_path__ + "img/transaction2.3e6a7dfb.jpg";